import type { ReactNode } from "react";

import Forbidden from "@/components/Forbidden";
import { useIsAdmin } from "@/lib/roles";

interface RoleGuardProps {
  children: ReactNode;
}

/**
 * Wraps an operator-only route. Renders the 403 page in place (rather than
 * redirecting) when the current user is not an admin, so customer deep-links
 * degrade gracefully instead of looping. Assumes an authenticated user — it is
 * nested inside {@link AuthGuard}.
 */
function RoleGuard({ children }: RoleGuardProps) {
  const isAdmin = useIsAdmin();
  if (!isAdmin) {
    return <Forbidden />;
  }
  return <>{children}</>;
}

export default RoleGuard;
